/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_qr_alt = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generated QR code`)
};

const es_qr_alt = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código QR generado`)
};

const de_qr_alt = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generierter QR-Code`)
};

const nl_qr_alt = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegenereerde QR-code`)
};

const fr_qr_alt = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR code généré`)
};

const it_qr_alt = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice QR generato`)
};

const pt_br2_qr_alt = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código QR gerado`)
};

const pt_qr_alt = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código QR gerado`)
};

const ja_qr_alt = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成されたQRコード`)
};

const zh_qr_alt = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已生成的二维码`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const qr_alt = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.qr_alt(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("qr_alt", locale)
	if (locale === "en") return en_qr_alt(inputs)
	if (locale === "es") return es_qr_alt(inputs)
	if (locale === "de") return de_qr_alt(inputs)
	if (locale === "nl") return nl_qr_alt(inputs)
	if (locale === "fr") return fr_qr_alt(inputs)
	if (locale === "it") return it_qr_alt(inputs)
	if (locale === "pt-BR") return pt_br2_qr_alt(inputs)
	if (locale === "pt") return pt_qr_alt(inputs)
	if (locale === "ja") return ja_qr_alt(inputs)
	return zh_qr_alt(inputs)
};